import { render, staticRenderFns } from "./vsTable.vue?vue&type=template&id=3c6806b9&"
import script from "./vsTable.vue?vue&type=script&lang=js&"
export * from "./vsTable.vue?vue&type=script&lang=js&"
import style0 from "./vsTable.vue?vue&type=style&index=0&id=3c6806b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports